import axios from 'axios'

import { getDeviceUniqueId, isObject } from '@/utils/miscellaneous'

const axiosInstance = axios.create({
  headers: {
    'app': process.env.REACT_APP_MSC_APP_ID
  }
})

axiosInstance.interceptors.request.use(async (config) => {
  const deviceId = await getDeviceUniqueId()

  if (deviceId) {
    // @ts-ignore
    config.headers['pushtkn'] = deviceId
  }

  // sanitizing "request" params data
  const requestData = config.params?.request
  if (requestData && isObject(requestData)) {
    Object.entries(requestData).forEach(([key, value]) => {
      requestData[key] = isObject(value) ? JSON.stringify(value) : value
    })
    config.params.request = JSON.stringify(requestData)
  }

  return config
})

axiosInstance.interceptors.response.use((value) => {
  if (value.headers['content-type'] === 'text/html' && value.data.result) {
    value.data.result = JSON.parse(value.data.result)
  }

  return value
})

export default axiosInstance
